import {useCopyToClipboard} from '@sollapay/web-core';

import type {CopyToClipboardOptions} from '@sollapay/web-core';

/** Copies the guest sign-in link to the account; `linkCopied` lets the copy button confirm it. */
export function useShareLink(trustAccountId: string) {
  const {copy, copied: linkCopied} = useCopyToClipboard('common', {showToast: false});

  const copyLink = (options?: Pick<CopyToClipboardOptions, 'showToast'>) =>
    copy(`${window.location.origin}/guest?account=${trustAccountId}`, options);

  return {copyLink, linkCopied};
}
